import {
  GROUPING_TYPES,
  TEAM_TYPES
} from "rivals/components/pages/Teams/types";
import RivalsDivider from "rivals/components/shared/Divider";
import Spinner from "rivals/components/shared/Spinner";
import {
  selectCollegeLetterGroupsAsTeamGroups,
  selectConferenceAsTeamGroups,
  selectConferencesAsTeamGroups
} from "rivals/redux/conference/selectors";
import {
  selectHighschoolGroupAsTeamGroups,
  selectHighschoolGroupsAsTeamGroups,
  selectHighschoolLetterGroupsAsTeamGroups
} from "rivals/redux/highschool/selectors";
import { useAppSelector } from "rivals/shared/utils/hooks";
import { setData } from "rivals/shared/utils/qa";
import Team from "./Team";
import styles from "./TeamsGroupsList.module.scss";
import type { Props, TeamsGroup } from "./types";

const TeamsGroupsList = ({
  loading,
  pageParams,
  philter
}: Props): JSX.Element => {
  const conferences = useAppSelector(selectConferencesAsTeamGroups);
  const collegeLetterGroups = useAppSelector(
    selectCollegeLetterGroupsAsTeamGroups
  );
  const conference = useAppSelector(selectConferenceAsTeamGroups);
  const highschoolGroups = useAppSelector(selectHighschoolGroupsAsTeamGroups);
  const highschoolLetterGroups = useAppSelector(
    selectHighschoolLetterGroupsAsTeamGroups
  );
  const highschoolGroup = useAppSelector(selectHighschoolGroupAsTeamGroups);

  const getTeamsGroupsToShow = (): TeamsGroup[] | undefined => {
    if (pageParams.type === TEAM_TYPES.COLLEGES) {
      if (pageParams.group) {
        return conference;
      }
      return pageParams.groupingType === GROUPING_TYPES.ALPHABETICALLY
        ? collegeLetterGroups
        : conferences;
    }

    if (pageParams.group) {
      return highschoolGroup;
    }
    return pageParams.groupingType === GROUPING_TYPES.ALPHABETICALLY
      ? highschoolLetterGroups
      : highschoolGroups;
  };

  if (loading) {
    return (
      <div className={styles.spinnerWrapper}>
        <Spinner philter={philter} />
      </div>
    );
  }

  return (
    <div
      className={styles.teamsGroupsListWrapper}
      {...setData(philter, "teams-groups-list")}
    >
      {getTeamsGroupsToShow()?.map(group => (
        <div className={styles.teamsGroupWrapper} key={group.id}>
          <RivalsDivider
            className={styles.divider}
            orientation="left"
            orientationMargin="0"
          >
            <h2 className={styles.teamsGroupTitle}>{group.title}</h2>
          </RivalsDivider>

          {group.teams?.map(team => (
            <Team key={team.id} team={team} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TeamsGroupsList;
